/* eslint-disable react/jsx-no-undef */
import React from "react";

// import { useNavigate } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import TopLogo from "../../components/layout/TopLogo";
// import bg from "../../assets/images/test_bg.png";
import TransparentButton from "../../components/button/TransparentButton";
import yellwSearch from "../../assets/images/icon/yellow-search.png"; //yellow-search.png
import bingoSuccess from "../../assets/images/success-test.png";
import logo from "../../assets/images/haier-logo.png";

export default function BingoSuccess() {
  const store = useSelector((state) => state.luckyDraw);
  const navigate = useNavigate();
  const bg = store['bgPicture']

  return (
    <>
      <TopLogo />
      {/* <div
        style={{
          background: `url(${bg}) no-repeat center center fixed`,
          minHeight: "calc(100vh - 60px)",
          padding: "25px",
          backgroundSize: "cover",
        }}
      >
        <div className="text-white text-center text-[34px] my-[10px]">
          ขอบคุณที่ร่วมกิจกรรม
        </div>

        <div className="bg-white pr-[30px]" style={{ borderRadius: "5px" }}>
          <div className="flex justify-start pb-[15px]">
            <img
              className="w-[32px] h-[32px]"
              style={{ margin: "auto" }}
              src={yellwSearch}
            />
            <div>
              <p className="text-yellow text-[34px]">
                อยู่ระหว่างตรวจสอบสิทธิ์
              </p>
              <p className="text-blue text-[20px] leading-[11px] ">
                ใช้เวลา 1 -2 วันในการยืนยันสิทธิ์ของคุณ
              </p>
            </div>
          </div>
        </div>

        <br></br>
        <br></br>
        <br></br>

        <div className="text-center mt-[50px]">
          <TransparentButton
            variant="contained"
            className="w-[70%]"
            onClick={() => {
              navigate("/bingo");
            }}
          >
            กลับหน้า Bingo
          </TransparentButton>
        </div>
      </div> */}
      <div
        style={{
          background: `url(${bg}) no-repeat center center fixed`,
          minHeight: "calc(100vh - 60px)",
          padding: "25px",
          backgroundSize: "cover",
        }}
      >
        <img
          className="mx-auto w-[250px] mt-[40px]"
          src={bingoSuccess}
          alt="logo"
        />

        <div className="text-white text-center text-[34px] mt-[-340px]">
          ขอบคุณที่ร่วมกิจกรรม
        </div>
        <img
          className="mx-auto w-[150px]"
          src={logo}
          alt="logo"
        />

        <div className="w-[250px] px-[30px] mt-[60px] text-lightBlue2 text-center text-[45px] leading-[45px] font-bold mx-auto">
          อยู่ระหว่างตรวจสอบสิทธิ์
        </div>
        <div className="w-[250px] px-[30px] mt-[10px] text-lightBlue2 text-center leading-[24px] text-[24px] mx-auto">
          ใช้เวลา 1-3 วัน
        </div>
        <div className="w-[250px] px-[30px] text-lightBlue2 text-center text-[24px] mx-auto">
          ในการยืนยันสิทธิ์ของคุณ
        </div>

        <div className="text-center mt-[100px]">
          <TransparentButton
            variant="contained"
            className="w-[70%]"
            // style={{
            //   position: "fixed",
            //   transform: "translate(-50%, -50%)",
            //   bottom: "50px",
            //   left: "50%",
            // }}
            onClick={() => {
              navigate("/bingo");
            }}
          >
            กลับหน้า Bingo
          </TransparentButton>
        </div>
      </div>
    </>
  );
}
